import React from 'react';
import { Tooltip, styled, tooltipClasses, TooltipProps } from '@mui/material';

export const TooltipStyled = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} className={className} classes={{ popper: className }} />
))(() => ({
  '&.MuiSvgIcon-root': {
    position: 'absolute',
    right: 2,
    top: 2,
    fontSize: '15px',
    zIndex: 2
  },
  [`&.${tooltipClasses.popper}`]: {
    zIndex: 2147483649
  }
}));
